module.exports = __webpack_public_path__ + "img/right_four.ed05e087.svg";